import * as React from 'react';
import { AppBar } from 'react-admin';
import Typography from '@mui/material/Typography';
import { API_HOST } from '../config';

const titleStyle = {
    textAlign: "center",
    flex: 1
  };

const logoStyle = {
    height: 36,
    marginTop: 8
}

const MyAppBar = (props) => (
    <AppBar
        sx={{
            "& .RaAppBar-title": {
                flex: 1,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
            },
        }}
        {...props}
        style={{
            backgroundColor: "#2196f3",
            color: "#FFFFFF"
        }}
    >
        <Typography
            variant="h4"
            color="inherit"
            style={titleStyle}
        >
            <img src={API_HOST+"/img/logo.png"} alt="logo" style={logoStyle} />
        </Typography>
    </AppBar>
);

export default MyAppBar;